import React, { useEffect, useState } from "react";
import Select from 'react-select';
import StandAloneInput from "../../../../../../components/stand-alone-input";

const CostCenter = (props) => {
  const [costCenterList, setCCList] = useState([]);
  const [selectedCC, setSelected] = useState({});

  useEffect(() => {
    setCCList(props.costCenters && props.costCenters.map(cc => ({ ...cc, key: cc.treeName, label: cc.treeName })) || []);
    let selected = costCenterList.find(to => to.key === props.costCenterTreeName);
    setSelected(selected);
  }, [props.costCenterTreeName]);

  function handleSelect(e) {
    setSelected(e);
    return props.onChange(e, "costCenterParent");
  };

  function onValueChange(e, fieldName) {

    return props.onChange(e, fieldName);
  };

  return (

    <div className="ec_setup_contact reg ">
      <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
        <div className="input_line ssD_fiels">
          <label>CC Tree name</label>
          <Select
            options={costCenterList}
            onChange={handleSelect}
            value={selectedCC}
            placeholder="Select Parent CC"
          >
          </Select>
        </div>
      </div>
    </div>
  );
};
export default CostCenter;
